import { createAction, props } from '@ngrx/store';
import {
  IPricingGroupByLocationProducts,
  IPricingGroupCreate,
  IPricingGroupUpdate,
} from '@boma/supplier-portal/shared/entities';

export const loadPricings = createAction(
  '[Pricing] Load Pricings',
  props<{
    payload: {
      entityId: string;
      params: {
        customerIds: string[];
        locationIds: string[];
        productIds: string[];
        groupBy?: string;
        deletedEntries?: boolean;
        promotions?: boolean;
      };
    };
  }>()
);

export const loadPricingsSuccess = createAction(
  '[Pricing] Load Pricings Success',
  props<{ data: any }>()
);

export const loadPricingsFailure = createAction(
  '[Pricing] Load Pricings Failure',
  props<{ error: any }>()
);

export const createPricingGroup = createAction(
  '[Pricing] Create Pricing Group',
  props<{
    payload: IPricingGroupCreate;
    onComplete: (response: IPricingGroupByLocationProducts) => any;
  }>()
);

export const createPricingGroupSuccess = createAction(
  '[Pricing] Create Pricing Group Success',
  props<{ payload: IPricingGroupByLocationProducts }>()
);

export const createPricingGroupFailure = createAction(
  '[Pricing] Create Pricing Group Failure',
  props<{ error: string }>()
);

export const updatePricingGroup = createAction(
  '[Pricing] Update Pricing Group',
  props<{
    id: string;
    payload: IPricingGroupUpdate;
  }>()
);

export const updatePricingGroupSuccess = createAction(
  '[Pricing] Update Pricing Group Success',
  props<{ payload: IPricingGroupUpdate }>()
);

export const updatePricingGroupFailure = createAction(
  '[Pricing] Update Pricing Group Failure',
  props<{ error: string }>()
);

export const deletePricingGroup = createAction(
  '[Pricing] Delete Pricing Group',
  props<{
    entityId: string;
    id: string;
  }>()
);

export const deletePricingGroupSuccess = createAction(
  '[Pricing] Delete Pricing Group Success',
  props<{ groupId: string }>()
);

export const deletePricingGroupFailure = createAction(
  '[Pricing] Delete Pricing Group Failure',
  props<{ error: string }>()
);
